export default {
  heading: 'Poppins, sans-serif',
  body: 'Poppins, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Reenie Beanie, cursive',
  googleFonts: ['Raleway', 'Reenie Beanie', 'Poppins'],
  customFamilies: ['Helvetica Bold'],
  customUrls: ['https://www.gonation.biz/fonts/helvetica/helvetica.css']
}
